import styled from 'styled-components';

export const containerConsultBarGraph = styled.div`
	width: 100%;
	/* background-color: yellow; */
`;
